function scheduleShippingBarUpdate(delay = 300) {
  if (window.__shippingBarUpdateScheduled) return
  window.__shippingBarUpdateScheduled = true
  setTimeout(() => {
    window.__shippingBarUpdateScheduled = false
    updateShippingProgressBar()
  }, delay)
}

function isCartMutationUrl(url) {
  if (!url) return false
  return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)
}

function updateShippingProgressBar() {
  const wrapper = document.querySelector('[data-shipping-progress-bar-wrapper]')
  if (!wrapper) return

  const threshold = parseInt(wrapper.dataset.threshold, 10)
  const bar = wrapper.querySelector('[data-shipping-progress-bar]')
  const diffEl = wrapper.querySelector('[data-shipping-progress-bar-difference]')
  const progressMsg = wrapper.querySelector('.progress_message')
  const completedMsg = wrapper.querySelector('.completed_message')

  fetch('/cart.js', { cache: 'no-store' })
    .then(res => res.json())
    .then(cart => {
      const total = cart.total_price
      const diff = threshold - total
      const progress = Math.min((total / threshold) * 100, 100)

      // Pause the cart-section observer while we mutate the DOM ourselves,
      // otherwise our own updates re-trigger the observer in an infinite loop.
      if (window.__shippingBarObserver) window.__shippingBarObserver.disconnect()

      bar.style.width = `${progress}%`

      if (diff <= 0) {
        progressMsg.classList.add('hidden')
        completedMsg.classList.remove('hidden')
      } else {
        diffEl.innerText = 'RD$' + Math.round(diff / 100).toLocaleString()
        progressMsg.classList.remove('hidden')
        completedMsg.classList.add('hidden')
      }

      if (window.__shippingBarObserver && window.__shippingBarObserverTarget) {
        window.__shippingBarObserver.observe(window.__shippingBarObserverTarget, {
          childList: true,
          subtree: true
        })
      }
    })
}

document.addEventListener('DOMContentLoaded', updateShippingProgressBar)
document.addEventListener('cart:updated', updateShippingProgressBar)

// Fallback for themes that do not emit cart:updated
document.addEventListener('DOMContentLoaded', () => {
  const cartContainer = document.querySelector('[data-ajax-cart-section]')

  if (!cartContainer) return

  const observer = new MutationObserver(() => {
    scheduleShippingBarUpdate(500)
  })

  window.__shippingBarObserver = observer
  window.__shippingBarObserverTarget = cartContainer

  observer.observe(cartContainer, {
    childList: true,
    subtree: true
  })
})

document.addEventListener('click', (e) => {
  const trigger = e.target.closest(
    '[data-ajax-cart-request-button], [data-add-to-cart], a[href^="/cart/change"]'
  )
  if (!trigger) return

  // Removals usually re-render the cart more slowly
  scheduleShippingBarUpdate(400)
})

// --- Hook global fetch to detect cart updates (robust) ---
(function () {
  const originalFetch = window.fetch
  window.fetch = function () {
    const fetchArgs = arguments
    return originalFetch.apply(this, fetchArgs).then(response => {
      try {
        const url =
          typeof fetchArgs[0] === 'string'
            ? fetchArgs[0]
            : fetchArgs[0] && fetchArgs[0].url

        if (isCartMutationUrl(url)) {
          scheduleShippingBarUpdate(300)
        }
      } catch (e) {}
      return response
    })
  }
})()



// --- Hook XMLHttpRequest (older themes) ---
(function () {
  const originalOpen = XMLHttpRequest.prototype.open
  XMLHttpRequest.prototype.open = function () {
    this.addEventListener('load', function () {
      try {
        if (isCartMutationUrl(this.responseURL)) {
          scheduleShippingBarUpdate(0)
        }
      } catch (e) {}
    })
    originalOpen.apply(this, arguments)
  }
})()
